import { Period } from './types';

export const getCurrentPeriod = (): Period => {
  const now = new Date();
  now.setDate(1);
  now.setHours(0, 0, 0, 0);
  return { year: now.getFullYear(), month: now.getMonth(), };
};

export const periodFromSearchParams = (params: URLSearchParams): Period | null => {
  const year = Number(params.get('year'));
  const month = Number(params.get('month'));
  if (params.get('year') === null || params.get('month') === null) return null;
  if (isNaN(year) || isNaN(month)) return null;
  return { year, month };
};

export const getMonthNameFromMonthIdx = (monthIdx: number): string=> {
  const date = new Date(2000, monthIdx, 1);
  return date.toLocaleString('ru-RU', { month: 'long' });
};
